import * as Yup from "yup";

/**
 * Règle de mot de passe unique de la plateforme.
 *
 * Doit rester alignée avec IsStrongPassword() côté backend
 * (src/common/validation/password.decorator.ts). Les deux écrans
 * appliquaient auparavant des règles différentes entre eux, si bien
 * qu'un mot de passe valide sur un formulaire pouvait être refusé
 * par l'API sur l'autre.
 */
export const passwordRule = Yup.string()
  .min(8, "Password must be at least 8 characters")
  .matches(/[a-z]/, "Password must contain at least one lowercase letter")
  .matches(/[A-Z]/, "Password must contain at least one uppercase letter")
  .matches(/[0-9]/, "Password must contain at least one digit")
  .matches(
    /[!@#$%^&*(),.?":{}|<>_\-]/,
    "Password must contain at least one special character"
  )
  .matches(/^\S*$/, "Password must not contain spaces");
